import styles from "./AzureConfigUnauthorized.module.scss";

export default function AzureConfigUnauthorized() {
  return (
    <div className={styles.page}>
      <main className={styles.main}>
        <h1 className={styles.heading}>Something went wrong</h1>
        <p className={styles.subheading}>
          There seems to be an issue with your computer&apos;s configurations.
        </p>
        <div className={styles.tryBlock}>
          <p className={styles.tryIntro}>Here are a few things to try:</p>
          <ul className={styles.list}>
            <li>Check that your system clock is set correctly</li>
            <li>Ensure your browser and OS are up to date</li>
            <li>Restart your computer</li>
          </ul>
        </div>
        <p className={styles.supportLine}>
          If you&apos;re still having trouble, please reach out to your IT team.
        </p>
      </main>
      <footer className={styles.footer}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Briefpoint
        </p>
      </footer>
    </div>
  );
}
